(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trDropdownSearch', trDropdownSearch);

  function trDropdownSearch() {
    const directive = {
      require: '^^stTable',
      restrict: 'E',
      scope: {
        filterOptionsMap: '<',
        selectPlaceholder: '@',
        selectedOption: '@',
        onOptionSelect: '&'
      },
      templateUrl: '/scripts/shared/directives/dropdown-search/dropdown-search.view.html',
      link: linkFunction
    };
    return directive;


    function linkFunction(scope, element, attr, table) {
      scope.filterOptions = Object.keys(scope.filterOptionsMap);
      table.setFilterFunction('trSmartTableCustomFilter');
      scope.fetchData = function() {
        const tableState = table.tableState();
        if(!tableState.search.predicateObject) {
          tableState.search.predicateObject = {};
        } else {
          tableState.search.predicateObject = {
            '$': tableState.search.predicateObject.$
          };
        }

        if (scope.selectedOption) {
          scope.onOptionSelect({ option: scope.selectedOption });
          tableState.search.predicateObject.customFilters = scope.filterOptionsMap[scope.selectedOption];
        }

        table.pipe(tableState);
      };

      scope.fetchData();
    }

  }
})();
